<template>
	<div class="m-list-view flex-grow flex-column">
		<topbar v-if="topbar" ref="topbar" :search="search" :filter="!!$slots.filter" :work-type="customView ? '' : workType" :custom-view="customView" @update="topbarHandle" @empty="state => emptyState = state">
			<template #link>
				<slot name="link"></slot>
			</template>
			
			<template #handle>
				<slot name="handle"></slot>
			</template>
			
			<template #filter>
				<slot name="filter"></slot>
			</template>
		</topbar>

		<c-empty v-if="emptyState" message="暂无可用视图，请联系管理员处理"></c-empty>

		<c-scroll-list ref="list" class="flex-grow" :head-height="headHeight" @refresh="loadTotal">
			<template #head>
				<slot name="head" :data="totalData"></slot>
			</template>

			<template #default="{data, index}">
				<slot :index="index" :data="data"></slot>
			</template>
		</c-scroll-list>
	</div>
</template>

<script>
	export default {
		name: 'viewList',

		props: {
			topbar: {
				type: Boolean,
				default: true
			},
			workType: [String, Number],
			customView: Object,
			search: [Boolean, Object],
			headHeight: [Number, String],
			immediate: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				coverField: null,
				titleField: null,
				countField: null,
				emptyState: false,
				totalData: {}
			}
		},

		computed: {
			totalUrl() {
				return {
					13: '/offline/sale/order/list/summary',
					22: '/storage/list/summary'
				}[this.workType]
			},

			dataUrl() {
				return {
					2: '/offline/purchase/order/list',		// 线下采购
					3: '/online/purchase/order/list',		// 线上采购
					7: '/quality/list',						// 质检管理
					10: '/sale/product/list',				// 商品管理
					11: '/sale/product/abnormal/list',		// 下架异常商品
					12: '/online/sale/order/list',			// 线上订单
					13: '/offline/sale/order/list',			// 线下订单
					14: '/oversold/sale/order/list',		// 超卖订单
					15: '/repair/list',						// 维修列表
					22: '/storage/list',        			// 库存管理
					27: '/handover/list',					// 接驳列表
					29: '/inventory/list',					// 盘点列表
					34: '/electronic/shelf/bindings/list',	// 电子货架
				}[this.workType]
			}
		},

		mounted() {
			this.immediate && this.load();
			this.$onShow(() => {
				this.update();
			});
		},

		activated() {
			if (this._deactivated) {
				delete this._deactivated;
				this.$refs.list.update();
			}
		},

		deactivated() {
			this._deactivated = true;
		},

		methods: {
			getParams() {
				return Object.assign({}, this.topbar ? this.$refs.topbar.params : null, this._parentParam)
			},

			load(param) {
				this._parentComplete = true;
				this._parentParam = param;
				this.loadData();
			},

			update() {
				this.$refs.list.update();
				this.$refs.topbar && this.$refs.topbar.updateTabTotal(this.dataUrl);
			},

			topbarHandle() {
				this._topbarComplete = true;
				this.loadData();
			},

			loadData() {
				if (!this.dataUrl) return;
				if (!this._parentComplete || (this.topbar && !this._topbarComplete)) return;
				this.$refs.list && this.$refs.list.load({
					url: this.dataUrl,
					data: this.getParams()
				});
				this.loadTotal();
			},

			loadTotal() {
				this.totalUrl && this.request({
					url: this.totalUrl,
					data: this.getParams(),
					success: data => {
						this.totalData = data;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-list-view {
		>>> .total-bar {
			display: flex;
			align-items: center;
			gap: .28rem;
			height: .75rem;
			padding: 0 .35rem;
			margin-bottom: -.24rem;
			font-size: .24rem;
			color: #666;
			background: #F2F2F2;
		}

		>>> .card {
			margin-top: .24rem;
		}
	}
</style>
